<div class="modal" style="z-index: 1500" id="ask_database" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3>Request a new database</h3>
      </div>
      <form #dbForm="ngForm" role="form" aria-label="database creation request form" class="user-form form-horizonal" (ngSubmit)="db_ask(dbForm)" novalidate>
        <div class="modal-body">
          <div class="form-group row col-sm-8">
            <label for="new_database_id">Name
              <span style="color: red">(required)</span>
              <span class="glyphicon glyphicon-question-sign" title="Unique name for the database" tooltip></span>
            </label>
            <input required placeholder="database name" type="text" maxlength="42" id="new_database_id" [ngModelOptions]="{ standalone: true }" [(ngModel)]="db.name" class="form-control" name="name" #name="ngModel" />
            @if (name.invalid && (name.dirty || name.touched)) {
              <div class="text-danger">
                @if (name.errors.required) {
                  <div>name required</div>
                }
              </div>
            }
          </div>
          <div class="form-group row col-sm-8">
            <label for="db_usage">Usage</label>
            <input placeholder="website, software,... " type="text" id="db_usage" [value]="1" [ngModelOptions]="{ standalone: true }" [(ngModel)]="db.usage" class="form-control" />
            <small id="nameHelp" class="form-text text-muted"><i>Optional, for information only</i></small>
          </div>
          <div class="form-group row col-sm-8">
            <label for="db_expire">Expiration date<span style="color: red">(required)</span></label>
            <input required type="date" id="db_expire" [ngModelOptions]="{ standalone: true }" [(ngModel)]="db_expire" class="form-control" name="expire" #expire="ngModel" />
            @if (expire.invalid && (expire.dirty || expire.touched)) {
              <div class="text-danger">
                @if (expire.errors.required) {
                  <div>expiration date required</div>
                }
              </div>
            }
          </div>
          <div class="form-group row col-sm-8">
            <label><input type="checkbox" [ngModelOptions]="{ standalone: true }" [(ngModel)]="db.single_user" />I will be the only one using this database</label>
          </div>
        </div>
        @if (form_msg) {
          <div class="alert alert-success alert-dismissible">{{ form_msg }}</div>
        }
        @if (form_err_msg) {
          <div class="alert alert-danger">{{ form_err_msg }}</div>
        }
        <div class="modal-footer">
          <div class="form-group row col-sm-12">
            <p-button type="submit" styleClass="btn btn-primary" label="Request MySQL Database"></p-button>
            <p-button type="button" styleClass="btn btn-secondary" data-bs-dismiss="modal" label="Close"></p-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
@if (session_user) {
  <p-button type="button" severity="primary" data-bs-toggle="modal" data-bs-target="#ask_database" label="Request A New Database"></p-button>
}

<div class="card bg-light">
  <div class="card-header">
    <h3>Databases</h3>
  </div>
  <div class="card-body">
    <div class="table-responsive table-striped">
      <p-table #dtp [value]="databases" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]="['name', 'type', 'host', 'owner']" [filterDelay]="0">
        <ng-template pTemplate="caption">
          <div class="table-header">
            <span class="p-input-icon-right">
              <i class="pi pi-search"></i>
              <input pInputText id="search_databases" type="text" (input)="dtp.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" />
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Owner</th>
            <th>Type</th>
            <th>Host</th>
            <th>Delete</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-database>
          <tr>
            <td>
              <span class="label label-primary">{{ database.name }}</span>
            </td>
            <td>
              <a routerLink="/user/{{ database.owner }}">
                <span class="label label-primary">{{ database.owner }}</span>
              </a>
            </td>
            <td>{{ database.type }}</td>
            <td>{{ database.host }}</td>
            <td><app-my-delete-confirm [onConfirm]="db_delete" [data]="database.name"></app-my-delete-confirm></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

@if (msg) {
  <div class="alert alert-success alert-dismissible" role="alert">{{ msg }}</div>
}
@if (err_msg) {
  <div class="alert alert-warning alert-dismissible" role="alert">{{ err_msg }}</div>
}
